import * as React from "react";
function MdIcon() {
    return React.createElement("path", { d: "M10.0001 17.7121L5.53857 13.2506L6.30457 12.4846L10.0001 16.1641L13.6956 12.4846L14.4616 13.2506L10.0001 17.7121ZM6.29657 7.5246L5.53857 6.75058L10.0001 2.28906L14.4616 6.75058L13.7036 7.5246L10.0001 3.8371L6.29657 7.5246Z", fill: "currentColor" });
}
export default MdIcon;
//# sourceMappingURL=Md.js.map